export { Wrapper } from './aside'
export { Detail, PaymentMethod } from './detail'
